import { render } from "./TotalIncome.vue?vue&type=template&id=1c6a0c28&ts=true"
import script from "./TotalIncome.vue?vue&type=script&lang=ts"
export * from "./TotalIncome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__